import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { updateRoute } from 'src/components/Router/actionCreators';

import { useTypedSelector } from './useTypedSelector';

export const useWindowHistory = () => {
  const dispatch = useDispatch();
  const latestRoute = useTypedSelector((state) => state.router.latestRoute);

  useEffect(() => {
    const windowHistoryListener = () => {
      if (latestRoute.mode === 'EDIT' && latestRoute.card) {
        dispatch(updateRoute({ to: latestRoute.card, mode: 'READ' }));
      }
    };

    window.addEventListener('popstate', windowHistoryListener);

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    const cleanupListener = () => {
      window.removeEventListener('popstate', windowHistoryListener);
    };

    return cleanupListener;
  }, [dispatch, latestRoute.card, latestRoute.mode]);
};
